import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DOC_ORIENTATION, NgxImageCompressService } from 'ngx-image-compress';

@Component({
  selector: 'app-attachment',
  templateUrl: './attachment.component.html',
  styleUrls: ['./attachment.component.scss']
})
export class AttachmentComponent implements OnInit {
  @Input() format;
  @Input() size;
  @Input() sizeFormat;
  @Output() selectedImage = new EventEmitter();
  errorMessage: string;
  imageLoading: boolean = false;
  image: any;
  imageName: any;


  constructor(private imageCompress: NgxImageCompressService) { }

  ngOnInit(): void {
  }

  onFileChange(event, action) {
    this.setLoadingImages(action, true, null, 'Updating');
    if (event.target.files && event.target.files.length) {
      const fileSize = event.target.files[0].size / 1024 / 1024; // in MiB
      // check file size
      if (fileSize > this.size) {
        this.errorMessage = `File size must be less than ${this.size}${this.sizeFormat}.`
        return;
      }
      // check file format
      if (!this.isValidFileType(event.target.files[0].name, event.target.files[0].type)) {
        this.errorMessage = `Invalid file format.`
        return;
      }
      const [file] = event.target.files;
      this.getBase64(file, (img: string) => {
        this.errorMessage = null;
        this.compressFile(img, action, file?.name);
      });
    }
  }

  compressFile(image, action, name) {
    this.imageCompress.compressFile(image, DOC_ORIENTATION.Up, 50, 50).then(
      result => {
        this.setLoadingImages(action, false, result, name);
      }
    );
  }

  private getBase64(img: File, callback: (img: string) => void): void {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result!.toString()));
    reader.readAsDataURL(img);
  }

  setLoadingImages(action, value, img?, name?) {
    this.imageLoading = value;
    if (img) {
      this.image = img;
      this.selectedImage.next(this.image);
      this.imageName = name.length > 25 ? `${name.substring(0, 25)}...` : name;
    }
  }

  isValidFileType(fName, fType) {
    let extensionLists = this.format.split(',')
    let index = extensionLists.findIndex((item) => {
      return item.replace(/ /g, '').toLowerCase() == fName.split('.').pop();
    });

    return index > -1;
  }

}
